import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '../../../common/layout/notification.service';
import { MyDocumentsService } from '../my-documents.service';

@Component({
    selector: 'ns-my-documents-list',
    templateUrl: './my-documents-list.component.html',
    styleUrls: ['./my-documents-list.component.scss']
})
export class MyDocumentsListComponent implements OnInit {

    @Input() public list;

    constructor(
        private notificationService: NotificationService,
        private myDocumentsService: MyDocumentsService,
    ) { }

    ngOnInit(): void {
    }

    public removeFile(doc) {
        if (doc) {
            this.notificationService.confirm(() => {
                this.myDocumentsService.removeFile(doc.id).then(
                    () => {
                        this.list.splice(this.list.indexOf(doc), 1);
                    }
                );

            }, {
                title: 'Potwierdzenie',
                content: 'Czy na pewno usunać ten plik z biblioteki?',
                width: 0
            });
        }
    }
    public download(doc) {
        if (doc && doc.file && doc.file.id) {
            window.open('/api/files/' + doc.file.id, '_blank');
        }
    }

    public getDate(val: string) {
        let tmp = val.substring(0, val.indexOf(' '));
        let arr = tmp.split('-')
        return arr[2] + '.' + arr[1] + '.' + arr[0];
    }
}
